import { RECORD_ANSWER } from '../actions/survey';

export default function surveyData(state={}, { type, key, value }) {
  switch (type) {
    case RECORD_ANSWER:
      return {
        ...state,
        [key]: value,
      };
    default:
      return state;
  }
}
